// extracted by mini-css-extract-plugin
export default {"list":"TitleDescriptionList_list__cMsT1","item":"TitleDescriptionList_item__P8qxZ","title":"TitleDescriptionList_title__PjSla"};